// extracted by mini-css-extract-plugin
module.exports = {"offer-hero":"OfferHero_offer-hero__vr92z","title":"OfferHero_title__Nc928"};